import { Injectable } from "@angular/core";
import { PointStats } from "../../model/point-stats";
import { ApiService } from "../../services/api";
import { PointStatListItem, EditedPointStats } from "../../lib/types/PointStatListItem";
import { RodeoPointSeriesNominationsDto } from "../../lib/types/RodeoPointSeriesNominationsDto";

@Injectable()
export class PointStatsApiService {
    async editPointStats(editedPointStats: EditedPointStats[]) {
        return await this.api.patchWithAuth(
            `${this.api.endpoints.pointStats}`, editedPointStats
        )
    }
    constructor(private api: ApiService) { }

    async savePointStats(pointStats: PointStats[]) {
        return await this.api.postWithAuth(this.api.endpoints.pointStats, pointStats);
    }

    async getRodeoPointStats(rodeoId: number, rodeoEventId: number, scheduleId: number, payoutConfigId: number, pointSeriesId: number) {
        return await this.api
            .getWithAuth<PointStatListItem[]>(
                `${this.api.endpoints.pointStats}/rodeos/${rodeoId}?rodeoEventId=${rodeoEventId}&scheduleId=${scheduleId}&payoutConfigId=${payoutConfigId}&pointSeriesId=${pointSeriesId}`
            );
    }

    async getRodeoRunsWithoutPoints(rodeoId: number, rodeoEventId: number, payoutConfigId: number, pointSeriesId: number) {
        return await this.api
            .getWithAuth<PointStatListItem[]>(
                `${this.api.endpoints.pointStats}/rodeos/${rodeoId}/nopoints/?rodeoEventId=${rodeoEventId}&payoutConfigId=${payoutConfigId}&pointSeriesId=${pointSeriesId}`
            );
    }

    async getRodeoNomination(rodeoId: number) {
        return await this.api.getWithAuth<RodeoPointSeriesNominationsDto[]>(
            `${this.api.endpoints.nominationpoints}/rodeos/${rodeoId}`
        );
    }
}


// WEBPACK FOOTER //
// ./src/services/points/pointStats.api.service.ts